export default __webpack_public_path__ + "static/media/mors_orless_preview.932ebbef.png";